import React from "react";
import PropTypes from "prop-types";
import styles from "./AddressCard.module.css";
import { AddressInfoItem } from "../AddressInfoItem/AddressInfoItem";
import { EditButton } from "../EditButton/EditButton";
import { Button } from "../Button/Button";
import { useTranslation } from "react-i18next";

/**
 * Interactive component
 *
 * Displays suggested or original address with option to Use Suggestion or Edit.
 */

export function AddressCard({
  original,
  address,
  title,
  onClickUse,
  onClickEdit,
}) {
  const { t } = useTranslation();
  if (original) {
    return (
      <div className={styles.containerOriginal}>
        <div className={styles.title}>{title}</div>
        <div className={styles.address}>
          <AddressInfoItem
            address={address}
            labelColor={"fff"}
            isInModal={true}
            isSuggested={false}
          />
        </div>
        <div className={styles.bottomRow}>
          <div>
            <Button
              buttonText={t("Use Original Address")}
              onClick={onClickUse}
              className={styles.originalButton}
            />
          </div>
          <div className={styles.buttonEdit}>
            <EditButton onClick={onClickEdit} />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.containerSuggested}>
        <div className={styles.title}>{title}</div>
        <div className={styles.address}>
          <AddressInfoItem
            address={address}
            labelColor={"fff"}
            isInModal={true}
            isSuggested={true}
          />
        </div>
        <div className={styles.bottomRow}>
          <Button
            buttonText={t("Use Suggested Address")}
            onClick={onClickUse}
            className={styles.suggestedButton}
          />
        </div>
      </div>
    );
  }
}

AddressCard.propTypes = {
  address: PropTypes.shape({
    recipient: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }),
  suggestedAddress: PropTypes.shape({
    recipient: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }),
  title: PropTypes.string,
  original: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onClickUse: PropTypes.func,
};

export default AddressCard;
